// src/components/common/IntercomProvider.js
import { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { useTheme } from '@mui/material/styles';

const IntercomProvider = ({ user }) => {
  const theme = useTheme();
  
  useEffect(() => {
    // Remove accent color configuration and let Intercom handle it
    
    if (typeof window !== 'undefined') {
      if (user && user.uid) {
        Intercom({
          app_id: 'k91garrd',
          user_id: user.uid,
          name: user.displayName || user.email?.split('@')[0] || '',
          email: user.email || '',
          created_at: user.metadata?.creationTime 
            ? Math.floor(new Date(user.metadata.creationTime).getTime() / 1000)
            : Math.floor(Date.now() / 1000),
          // Custom attributes
          isPro: user.isPro || false,
          theme: theme.palette.mode, // Send theme mode (dark/light)
          // Messenger customization
          hide_default_launcher: true,
          alignment: 'right',
          horizontal_padding: 20,
          vertical_padding: 20,
          custom_launcher_selector: '#custom-intercom-launcher'
          // Remove action_color to let Intercom handle colors
        });
      } else {
        Intercom({
          app_id: 'k91garrd',
          hide_default_launcher: true,
          // Customization for unauthenticated users
          alignment: 'right',
          horizontal_padding: 20,
          vertical_padding: 20,
          theme: theme.palette.mode
          // Remove action_color
        });
      }
    }

    return () => {
      if (typeof window !== 'undefined' && window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, [user, theme.palette.mode]);

  return null;
};

export default IntercomProvider;